import { useState, useRef } from "react";
import { Calendar } from "lucide-react";

export default function EuropeanDateInput({ value, onChange, className }) {
  const dateInputRef = useRef(null);
  
  // Convertir de ISO (yyyy-mm-dd) a formato europeo (dd/mm/yyyy) para mostrar
  const formatToEuropean = (isoDate) => {
    if (!isoDate) return "";
    const [year, month, day] = isoDate.split("-");
    return `${day}/${month}/${year}`;
  };

  // Convertir de formato europeo (dd/mm/yyyy) a ISO (yyyy-mm-dd) para guardar
  const formatToISO = (euroDate) => {
    if (!euroDate || euroDate.length !== 10) return "";
    const [day, month, year] = euroDate.split("/");
    return `${year}-${month}-${day}`;
  };

  const [displayValue, setDisplayValue] = useState(formatToEuropean(value));

  const handleDisplayChange = (e) => {
    let input = e.target.value.replace(/[^\d]/g, ""); // Solo números
    
    // Formatear automáticamente con /
    if (input.length >= 2) {
      input = input.slice(0, 2) + "/" + input.slice(2);
    }
    if (input.length >= 5) {
      input = input.slice(0, 5) + "/" + input.slice(5, 9);
    }
    
    setDisplayValue(input);
    
    // Validar y convertir a formato ISO cuando esté completo
    if (input.length === 10) {
      const [day, month, year] = input.split("/");
      const dayNum = parseInt(day, 10);
      const monthNum = parseInt(month, 10);
      const yearNum = parseInt(year, 10);
      
      if (dayNum >= 1 && dayNum <= 31 && monthNum >= 1 && monthNum <= 12 && yearNum >= 1000) {
        const isoDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        onChange(isoDate);
      }
    } else if (input.length === 0) {
      onChange("");
    }
  };

  const handleDateInputChange = (e) => {
    const isoDate = e.target.value;
    setDisplayValue(formatToEuropean(isoDate));
    onChange(isoDate);
  };

  const openCalendar = () => {
    dateInputRef.current?.showPicker?.();
  };

  return (
    <div className="relative">
      {/* Input visible con formato dd/mm/yyyy */}
      <input
        type="text"
        className={className}
        value={displayValue}
        onChange={handleDisplayChange}
        placeholder="DD/MM/YYYY"
        maxLength={10}
      />
      
      {/* Icono de calendario */}
      <button
        type="button"
        onClick={openCalendar}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
      >
        <Calendar size={18} />
      </button>
      
      {/* Input date oculto para el calendar picker */}
      <input
        ref={dateInputRef}
        type="date"
        className="absolute opacity-0 pointer-events-none"
        value={value || ""}
        onChange={handleDateInputChange}
        tabIndex={-1}
      />
    </div>
  );
}
